import {
  Component,
  Input,
  OnChanges,
  OnInit,
  signal,
  SimpleChanges,
  WritableSignal
} from '@angular/core';

@Component({
  selector:    'lm-facade-unknown-detail',
  standalone: false,
  templateUrl: './lm-facade-unknown-detail.component.html',
  styleUrl: './lm-facade-unknown-detail.component.scss',
})
export class LMFacadeUnknownDetailComponent implements OnInit, OnChanges {

  @Input() request: LMFacadeDetailRequest | undefined;

  undefinedInfo: LMFacadeDetailRequest = {
    type: 'undefined',
  };
  propertiesLabel = Soho.Locale.translate("CreateReportPropertiesTab");
  emptyTitle = Soho.Locale.translate("Facade_ReportPropertiesEmptyTitle");
  emptyDesc = Soho.Locale.translate("Facade_ReportPropertiesEmptyDesc");

  info: WritableSignal<LMFacadeDetailRequest> = signal(this.undefinedInfo);

  ngOnInit(): void {
    if (this.request) {
      this.info.set(this.request);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.request && changes.request) {
      this.info.set(this.request);
    }
  }
}
